import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    Button,
    ControlLabel,
    FormControl,
    FormGroup,
    Radio,
    OverlayTrigger,
    Tooltip
} from 'react-bootstrap';
import TooltipContainer from '../../../components/shared/FormBuilder/controls/Tooltip';
import { copy } from '../../constants';

export class InviteUser extends Component {
    constructor(props) {
        super(props);
        const { invitation } = props;
        this.refEmailInput = null;

        this.state = {
            isAdminSelectorVisible: props.adminSelectorVisibility === 'visible' || false,
            isBusy: false,
            invitation: {
                email: invitation.email || '',
                isAdmin: 'true',
                type: 'broker'
            }
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillReceiveProps(props) {
        const { invitation } = this.state;

        if (this.state.isBusy && !props.invitation) {
            invitation.email = '';
            this.setState({
                invitation,
                isBusy: false
            });
        }
        this.setState({
            isBusy: props.isBusy === true
        });

        this.refEmailInput.focus();
    }

    handleChange(e) {
        const { name, value } = e.target;
        const { invitation } = this.state;
        invitation[name] = value;

        this.setState({
            invitation
        });
    }

    handleSubmit(e) {
        this.setState({
            isBusy: true
        });
        this.props.onSubmit(this.state.invitation);
        e.preventDefault();
    }

    render() {
        const { data } = this.props;

        const tooltip = (
            <Tooltip id="adminSelectTooltip">
                <span>
                    {copy.lang('brokersInviteGroupTooltip', {
                        brokerageName: copy.clean(data.brokerageName) || 'Brokerage'
                    })}
                </span>
            </Tooltip>
        );

        return (
            <div className="newUserComponent">
                <h1>Invite broker</h1>
                <form onSubmit={this.handleSubmit}>
                    <br />
                    <FormGroup controlId="email">
                        <ControlLabel>Email address</ControlLabel>
                        <FormControl
                            type="email"
                            name="email"
                            className="adminInput"
                            required
                            onChange={this.handleChange}
                            value={this.state.invitation.email}
                            className="emailInput"
                            disabled={this.state.isBusy}
                            inputRef={ref => {
                                this.refEmailInput = ref;
                            }}
                        />
                    </FormGroup>
                    <Button type="submit" disabled={this.state.isBusy || data.brokerageStatus === 'disabled'}>
                        Send Invite
                    </Button>
                </form>
            </div>
        );
    }
}

InviteUser.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    adminSelectorVisibility: PropTypes.string
};
